import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 5rem 3.2rem 1.2rem;
  width: 49.5rem;
`;

export const Subtitle = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.primaryBlue};
  `}
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0;
`;

export const Title = styled.h1`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  margin-top: 0.5rem;
`;

interface ISectionTitle {
  light?: any;
  small?: any;
}
export const SectionTitle = styled.h3<ISectionTitle>`
  ${({ theme, light, small }) => `
    color: ${
      light
        ? theme.colors.blackTextBody + theme.transparencies.p30
        : theme.colors.blackTextBody
    };
    font-size: ${small ? "1.2rem" : "1.4rem"};
  `}
  font-weight: 700;
`;

export const StatusContainer = styled.div`
  margin-bottom: 3.6rem;
  width: 14.5rem;
`;

export const InfoContainer = styled.div`
  margin-bottom: 1.2rem;
  .dispatcher-container {
    padding-top: 1.6rem;
  }

  height: 30vh;
  overflow-y: auto;

  @media (max-height: 930px) {
    height: 42vh;
  }
  @media (max-height: 870px) {
    height: 37vh;
  }
  @media (max-height: 800px) {
    height: 33vh;
  }
  @media (max-height: 750px) {
    height: 30vh;
  }
  @media (max-height: 720px) {
    height: 27vh;
  }
  @media (max-height: 690px) {
    height: 23vh;
  }
`;

export const MainButton = styled.button`
  ${({ theme }) => `
  color: ${theme.colors.white};
  background-color: ${theme.colors.accentGreen};
`}

  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.2rem;
  justify-content: center;
  width: 43.1rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: not-allowed;
  }
`;

export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 3rem;
`;

export const VehicleContainer = styled(RowContainer)`
  border-radius: 1rem;
  border: ${({ theme }) => `1px solid ${theme.colors.backgroundGray2}`};
  display: grid;
  grid-template-columns: 1fr;
  padding: 0.5rem 1.4rem;
`;

export const VehicleRow = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const VolanteContainer = styled.div`
  align-items: center;
  border-radius: 1rem;
  box-shadow: 0px 5px 50px rgba(231, 231, 234, 0.62);
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1.4rem;
`;

interface IText {
  small?: any;
}
export const Text = styled.p<IText>`
  ${({ theme, small }) => `
    color: ${theme.colors.blackTextBody};
    font-size: ${small ? "1.4rem" : "1.6rem"};
  `}
  font-weight: 500;
`;

interface Ismall {
  small?: any;
}
export const BoldText = styled.p<Ismall>`
  ${({ theme }) => `
    color: ${theme.colors.blackTextTitle};
  `}
  font-size: 1.5rem;
  font-weight: bold;
`;

export const DivContentTurn = styled.div`
  background-color: red;
`;

export const DivFlexColumContentTurn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export const DivContentImgTurn = styled.div`
  align-items: center;
  color: #08082b;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: center;
  width: 24rem;
  .icon-check-success {
    height: 12rem;
    width: 21.3rem;
  }

  .icon-loading {
    height: 6rem;
    width: 6rem;
  }
  .icon-loading-gray {
    height: 5rem;
    width: 5rem;
  }
`;

export const DivLabelTurn = styled.div`
  color: rgba(8, 8, 43, 0.55);
  font-weight: 500;
  margin-top: 1rem;
  text-align: center;
`;
interface IDivLabelTurnStep {
  color?: string;
  fontSize?: string;
  fontWeight?: number;
  marginTop?: string;
}
export const DivLabelTurnStep = styled.div<IDivLabelTurnStep>`
  ${(props) => `
    color: ${props.color ? props.color : "#2E353D"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-size: ${props.fontSize ? props.fontSize : "1.6rem"};
    font-weight: ${props.fontWeight ? props.fontWeight : 500};
    margin-top: ${props.marginTop ? props.marginTop : "0rem"};
  `}
`;

export const DivContentRestriction = styled.div`
  align-items: center;
  background: rgba(255, 111, 97, 0.1);
  display: flex;
  justify-content: center;
  margin-bottom: 0.8rem;
  padding: 1rem;
`;

export const DivLabelRestriction = styled.div`
  color: #ff6f61;
  font-size: 1.4rem;
  margin-left: 1rem;
`;

export const DivFlexJustifyTurn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const DivFlexJustifyAlignTurn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const DivContentAlert = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 5rem;
`;

export const DivLabelAlert = styled.div`
  color: #08082b;
  font-size: 2rem;
  font-weight: 700;
  margin-top: 1.7rem;
`;

export const DivContentVct = styled.div`
  align-items: center;
  color: #2e353d;
  display: flex;
  font-family: Montserrat;
  font-size: 1.6rem;
  font-weight: 500;
  justify-content: space-between;
`;

export const DivErrorComments = styled.div`
  color: #ff6f61;
  font-family: Montserrat;
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
`;

export const DivRestrictions = styled.div`
  background: #ffffff;
  box-shadow: 0px 10px 60px rgba(231, 231, 234, 0.62);
  font-family: Montserrat;
  height: 9.9rem;
  margin-bottom: 0.8rem;
  padding: 1.6rem;
  width: 43rem;
`;
export const DivNumVolante = styled.div`
  color: #000000;
  font-size: 1.4rem;
  margin-top: 1.2rem;
`;

export const DivContentWarningComment = styled.div`
  font-family: Montserrat;
  margin-bottom: 1.5rem;
`;

export const DivLabelWarningComment = styled.div`
  color: #002e6c;
  font-size: 1.6rem;
  font-weight: 600;
  text-align: center;
`;

export const DivContentAlertContinue = styled.div`
  background: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  border: 1px solid #e7e7ea;
  height: 9.8rem;
  margin-bottom: 2rem;
  padding: 2.5rem;
  width: 43rem;
`;

export const DivLabelAlertContinue = styled.div`
  color: #c4c4c4;
  font-size: 1.4rem;
  text-align: center;
`;

interface IDivContentBorder {
  border?: string;
}
export const DivContentBorder = styled.div<IDivContentBorder>`
  margin-top: 2rem;
  border-radius: 8px;
  padding: 1rem;
  width: 43rem;
  height: 31rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  ${(props) => `
  border: ${props.border ? props.border : "1px solid #FFFFFF"};
`}
`;
